export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13511.b94008d0.jpg";